import { Pipe, PipeTransform } from '@angular/core';
import {
    Alert,
    BeaconPropertyType,
    DataTypes,
    Direction,
    GroupType,
    Permission,
    RecordState,
    TagPriority,
    PhotoRelation,
    Hardware,
    MonthList,
    ObjectSafetyStatus,
    TileExtension,
    TrackItemKind
} from '@app/core/constants/global-enum';
import { LiveDTO } from '@app/modules/live/dtos/live';

@Pipe({
    name: 'globalEnumPipe',
    standalone: false
})
export class GlobalEnumPipe implements PipeTransform {

    transform(
        value: number,
        enumType:
            'recordState' |
            'tagState' |
            'permission' |
            'alert' |
            'grouptype' |
            'priority' |
            'direction' |
            'dataType' |
            'photoRelation' |
            'hardware' |
            'monthList' |
            'trackItemKind' |
            'status' |
            'tileExtension'
    ): any {
        switch (enumType) {
            case 'recordState':
                return RecordState[value];
            case 'tagState':
                return BeaconPropertyType[value];
            case 'permission':
                return Permission[value];
            case 'alert':
                return Alert[value];
            case 'grouptype':
                return GroupType[value];
            case 'priority':
                return TagPriority[value];
            case 'direction':
                return Direction[value];
            case 'dataType':
                return DataTypes[value];
            case 'photoRelation':
                return PhotoRelation[value];
            case 'hardware':
                return Hardware[value];
            case 'monthList':
                return MonthList[value];
            case 'trackItemKind':
                return TrackItemKind[value];
            case 'status':
                return ObjectSafetyStatus[value];
            case 'tileExtension':
                return TileExtension[value];

        }
    }
}
